// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"48198676","265":"0475d6a1","740":"b5230c76","807":"aa58d00f","899":"abced021","900":"815301c4","996":"c36b3afe"}[chunkId] + ".chunk.js";
};